/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Scope_BodyInputs */

const en_svc_integration_scope_body = /** @type {(inputs: Svc_Integration_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most businesses already have the data and the tools. What is missing is the step that reads unstructured input — an email, a PDF, a note — and turns it into something the software can use.`)
};

const lv_svc_integration_scope_body = /** @type {(inputs: Svc_Integration_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lielākajai daļai uzņēmumu dati un rīki jau ir. Trūkst soļa, kas izlasa nestrukturētu informāciju — e-pastu, PDF, piezīmi — un pārvērš to par kaut ko, ar ko programmatūra var strādāt.`)
};

/**
* | output |
* | --- |
* | "Most businesses already have the data and the tools. What is missing is the step that reads unstructured input — an email, a PDF, a note — and turns it into ..." |
*
* @param {Svc_Integration_Scope_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_scope_body = /** @type {((inputs?: Svc_Integration_Scope_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Scope_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_scope_body(inputs)
	return en_svc_integration_scope_body(inputs)
});